import { db } from "./FirebaseService";
import { ref, set, onDisconnect, serverTimestamp, onValue } from "firebase/database";

// Private state using closure
let presenceRef = null;
let connectionRef = null;
let isConnected = false;
let currentUid = null;

const VENDOR_ID = process.env.VUE_APP_VENDOR_ID;

/**
 * Initialize presence tracking for a user
 * @param {string} uid - User ID
 */
export const initializePresence = async (uid) => {
  if (!uid) {
    console.warn('PresenceService: No UID provided for presence initialization');
    return;
  }

  currentUid = uid;
  presenceRef = ref(db, `live_visitors/${VENDOR_ID}/${uid}`);
  connectionRef = ref(db, '.info/connected');

  // Listen for connection state changes
  onValue(connectionRef, (snapshot) => {
    isConnected = snapshot.val();
    
    if (isConnected) {
      setPresence();
    }
  });
};

/**
 * Set presence data in the database
 */
const setPresence = async () => {
  if (!presenceRef || !currentUid) {
    return;
  }

  try {
    const presenceData = {
      userAgent: navigator.userAgent,
      lastVisit: serverTimestamp()
    };

    // Set presence data
    await set(presenceRef, presenceData);

    // Set up disconnect cleanup
    await onDisconnect(presenceRef).remove();
  } catch (error) {
    console.error('PresenceService: Error setting presence:', error);
  }
};

/**
 * Clean up presence tracking
 */
export const dispose = () => {
  currentUid = null;
  presenceRef = null;
  connectionRef = null;
  isConnected = false;
};
